<template>
  <standard-dialog
    v-model="model"
    :title="$t('add_to_waybill')"
    icon="mdi-package-variant"
    :save-text="$t('add')"
    :disabled="!grocery || quantity <= 0"
    @save="save"
  >
    <v-form ref="form" v-model="valid">
      <grocery-picker
        v-model="grocery"
        :groceries="warehouseInventory"
        required
        :label="$t('warehouse.choose_article')"
        persistent-hint
        :loading="loading"
        :rules="[rules.required]"
        :hint="
          !inventoryLoaded
            ? $t('loading_inventory_please_wait')
            : $t('only_available_items_shown')
        "
      />
      <text-field
        :label="$t('warehouse.warehouse_status')"
        type="number"
        :value="grocery ? grocery.quantity || 0 : null"
        :suffix="grocery?.measure || ''"
        readonly
      />
      <text-field
        v-model="quantity"
        :label="$t('quantity') + $t('warehouse.for_waybill')"
        type="number"
        :suffix="grocery ? grocery.measure : ''"
        :max="grocery?.quantity || 0"
        :rules="[rules.required]"
        required
      />
    </v-form>
  </standard-dialog>
</template>

<script>
import hasModel from "@/mixins/hasModel";
import hasValidation from "@/mixins/hasValidation";
import hasSnackbar from "@/mixins/hasSnackbar";
import warehouseService from "@/services/warehouse";
import GroceryPicker from "@/components/groceries/fields/GroceryPicker.vue";
import StandardDialog from "@/components/dialogs/StandardDialog.vue";

export default {
  mixins: [hasModel, hasValidation, hasSnackbar],
  props: {
    warehouse: {
      type: [Object, null, undefined],
      required: true,
    },
    groceries: {
      type: Array,
      required: true,
    },
  },
  components: {
    GroceryPicker,
    StandardDialog,
  },
  data: () => ({
    grocery: null,
    quantity: null,
    loading: false,
    inventory: [],
    inventoryLoaded: false,
  }),
  methods: {
    async getInventory() {
      this.loading = true;
      try {
        const { data } = await warehouseService.getInventory();
        this.inventory = data;
        this.inventoryLoaded = true;
      } catch (error) {
        this.showErrorSnackbar(error, this.$t("error_loading_inventory"));
      } finally {
        this.loading = false;
      }
    },
    save() {
      const grocery = {
        id: this.grocery.grocery_id,
        grocery_id: this.grocery.grocery.id,
        code: this.grocery.grocery.code,
        name: this.grocery.grocery.name,
        measure: this.grocery.measure,
        quantity: Math.max(0, Number(this.quantity)),
        warehouse_stock: this.grocery.quantity || 0,
        warehouse_id: this.warehouse.id,
        grocery: this.grocery,
        warehouse: this.warehouse,
        transaction_type: "order",
      };
      this.$emit("groceryAdded", grocery);
      this.model = false;
    },
  },
  computed: {
    warehouseInventory() {
      return this.inventory
        .filter((item) => item.warehouse_id === this.warehouse.id)
        .map((item) => ({
          ...item,
          ...item.grocery,
        }));
    },
  },
  watch: {
    grocery(newVal) {
      if (!this.grocery) return;
      const grocery = this.groceries.find((item) => item.id === newVal.id);
      if (grocery) {
        this.quantity = grocery.quantity;
      }
    },
    model(newVal) {
      if (newVal) {
        if (!this.inventoryLoaded) {
          this.getInventory();
        }
      } else {
        this.grocery = null;
        this.quantity = null;
        this.$refs.form.resetValidation();
      }
    },
  },
};
</script>
